<template>
  <section class="foyer">
    <div class="background-container">
      <Header v-if="!hideHeader" @headerRouteClicked="sendReturnMessage" />
      <iframe v-show="showFrame" :class="{ 'foyer-iframe': !setZ, 'foyer-iframe zindex': setZ }" id="the_iframe" ref="the_iframe" :src="foyerSrc" frameborder="0"></iframe>
      <!-- <iframe v-show="showFrame" class="foyer-iframe" id="the_iframe" src="https://proto-assets.s3.amazonaws.com/semesp/foyer/360/index.html" frameborder="0"></iframe> -->
    </div>
    <div class="footer-wrapper">
      <!-- <div style="cursor:pointer; width:100%; height:60px;display:flex;justify-content:center" @click.prevent="sendReturnMessage"> -->
      <img class="foyer-instructions" :src="imageHelp" v-if="imageHelp" />
      <!-- </div> -->
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';

export default {
  name: 'Foyer',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      hideHeader: true,
      footerKey: 0,
      showFrame: true,
      setZ: false,
      activityData: {},
      foyerSrc: '', //https://proto-assets.s3.amazonaws.com/semesp/foyer/360/index.html
      imageHelp: '', //https://proto-assets.s3.amazonaws.com/semesp/foyer/360/img/drags/drag%2B%2B.png
    };
  },

  computed: {
    mainActivity() {
      if (this.$store.state.availableActivities.length == 1) {
        return {
          name: 'Activity',
          params: {
            stream: this.$store.state.availableActivities[0].activity_id,
          },
        };
      } else {
        return {
          name: 'ActivityList',
        };
      }
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },

  methods: {
    sendReturnMessage() {
      // console.log('INFO');
      this.$refs.the_iframe.contentWindow.postMessage('return', '*');
    },
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          //console.log(response);
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          const tempProperty = { src: '', img: '' };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
          this.imageHelp = this.activityData.property.imageHelp;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;
          this.foyerSrc = this.activityData.property.src;

          // PONTOS.HTML APPEND QUERY
          if (this.activityData.property.src.includes('pontos.html')) {
            let { eventId, user } = this.$store.state;
            this.foyerSrc = `${this.activityData.property.src}?event_id=${eventId}&user_id=${user.id}&token=${user.token}&username=${user.name}`;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    messagesHandler(e) {
      try {
        let received = JSON.parse(e.data);

        if (received.url) {
          window.open(received.url);
          api.post(`sessionAction/`, {
            action: 'Foyer Action - External URL',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        }
        if (received.name) {
          api.post(`sessionAction/`, {
            action: 'Foyer Action - Route',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          this.$router.push(received).catch((err) => {
            console.error('navigation error', err);
          });
        }
        if (received.sessionAction) {
          api.post(`sessionAction/`, {
            action: 'Foyer Action - Internal Object',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        }
        // console.log('api.post sessionAction/ ' + e);
      } catch (e) {
        // console.log('Parsing error: ' + e);
      }
    },
  },

  beforeMount() {
    this.loadActivity();
  },
  mounted() {
    window.addEventListener('message', this.messagesHandler, false);
    this.$nextTick(() => {
      this.footerKey++;
      setTimeout(() => {
        this.$refs.the_iframe.focus(); // focus to propagate arrow keys to the iframe
      }, 1000);
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messagesHandler);
  },
};
</script>

<style lang="scss">
.background-container {
  background-color: var(--main-color);
  min-height: 97vh;
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10%;
  height: 100%;
  width: 100%;
  outline: none;
}

.foyer-iframe {
  position: absolute;
  top: 0;
  left: 0;
  height: 100dvh;
  width: 100vw;
  z-index: 1;
}

.zindex {
  z-index: 2;
}

.foyer-instructions {
  width: 180px;
  height: 100%;
  margin-bottom: 4px;
  user-select: none;
  object-fit: contain;
  @include media('<=phone') {
    display: none;
  }
}
</style>
